import React, { Fragment, memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar'
import Hero from '../../components/hero';
import About from '../../components/about';
import Opportunity from '../../components/Opportunity';
import Features from '../../components/Features';
import ServiceSection from '../../components/Services';
import FunFact from '../../components/FunFact';
import CustomBanner from '../../components/CustomBanner';
import LevelTest from '../../components/LevelTest';
import BlogSection from '../../components/BlogSection';
import ContactHome from '../../components/ContactHome';
import ProjectSection from '../../components/Projects';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { Helmet } from 'react-helmet-async';

const HomePage = memo(({ lang }) => {
    const { i18n } = useTranslation();

    // Sync language with URL-based lang prop when provided
    useEffect(() => {
        if (lang && ['en', 'ar'].includes(lang) && lang !== i18n.language) {
            i18n.changeLanguage(lang);
            localStorage.setItem('language', lang);
            document.documentElement.lang = lang;
        }
    }, [lang, i18n]);

    return (
        <Fragment>
            <Helmet>
                <title>Learn Arabic Online - Master the Arabic Language</title>
                <meta name="description" content="Join our e-learning platform to master Arabic. Interactive lessons, expert instructors, and comprehensive courses for all levels." />
            </Helmet>
            <Navbar Logo={Logo} hclass={'wpo-header-style-1'} />
            <Hero />
            <About />
            <Opportunity />
            <Features />
            <ServiceSection />
            <FunFact />
            <ProjectSection />
            <CustomBanner />
            <LevelTest />
            <BlogSection />
            <ContactHome cClass={'compact'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
});

export default HomePage;